import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface FeatureConsumeAllResponse {
  id: number;
  roll_consume_summary_id: number;
  feature_summary_id: number;
  uid: number;
  owner_type: number;
  owner_id: number;
  pid: number;
  event: string;
  feature_code: string;
  consume_count: number;
  type: number;
  create_time: number;
  user: User;
};

export interface User {
  id: number;
  username: string;
  email: string;
  first_login: boolean;
  region: string;
  registration_source: string;
  status: string;
  avatar: string;
  last_login_at: Date;
  last_login_ip: string;
  login_count: number;
  first_dh_create: number;
  in_waiting_queue: number;
  created_type: string;
  last_visit_workspace_id: number;
  agent_admin: number;
  agent_admin_status: number;
  agent_first_login: number;
  device_id?: string;
  gender: string;
  company?: string;
  personal_title?: string;
  is_agent: number;
  user_global_id?: string;
  notification_enabled: number;
  admin_name: string;
  team_ids: string;
  created_at: string;
  updated_at: string;
};


// 请求接口
interface FeatureConsumeAllRequest {
  pid: number;
  featureCode: string;
  page?: number;
  pageSize?: number;
}

export class UserData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Username cannot be empty")
  @IsString("Username must be a string")
  username: string;
}

export class FeatureConsumeAllData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Pid cannot be empty")
  @IsNumber("Pid must be a number")
  pid: number;

  @Required("Consume count no cannot be empty")
  @IsNumber("Consume count must be a number")
  consumeCount: number;

  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;

  @Required("Feature code cannot be empty")
  @IsString("Feature code must be a string")
  featureCode: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;

  @Required("Event cannot be empty")
  @IsString("Event must be a string")
  event: string;

  @Required("Feature name cannot be empty")
  @IsString("Feature name must be a string")
  featureName: string;

  @Required("User cannot be empty")
  user: User;
}

export class FeatureConsumeAllListData {
  @Required("Feature consume all list cannot be empty")
  @IsArray("Feature consume all list must be an array")
  data: FeatureConsumeAllData[];
}

const transformAndValidateFeatureConsumeAll = (
  response: { data: FeatureConsumeAllResponse }
): FeatureConsumeAllListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, FeatureConsumeAllListData);
  } catch (error) {
    console.error("Feature consume all data validation failed:", error.message);
    throw error;
  }
};

/** 获取消费明细 */
export const featureConsumeAll = async (agentId: string, { pid, featureCode, page, pageSize }: FeatureConsumeAllRequest): Promise<FeatureConsumeAllListData> => {
  const response = await api.post<FeatureConsumeAllResponse>('/feature_consume/all', {
    pid,
    feature_code: featureCode,
    page,
    page_size: pageSize,
  }, agentId ? {
    headers: {
      'Team-Code': agentId || '',
    },
  } : {});
  const data = transformAndValidateFeatureConsumeAll(response);
  return data;
};
